<lib-filtered-table
  [tableId]="'history'"
  [tableTitle]="'request_details_screen_history_tab_table_title' | transloco"
  [columns]="columns"
  [dataSource]="historyData()"
  [isLoadingData]="isLoading()"
  [meta]="meta()"
  [tableFilterTabs]="tableFilterTabs"
  [filterOptions]="filterOptions"
  [filterMapping]="filterMapping"
  [searchPlaceholder]="'my_task_screen_search_input_placeholder'"
  [isTableExportable]="true"
  [applyOnStreamChanges]="checkReturnedObservable"
  [(payload)]="payload"
  (streamSucceeds)="handleHistoryStreamSuccess($event)"
  (submitExport)="submitExportForm($event)"
  (handleApiCall)="handleApiCall()"
  [tableColumnTemplates]="[
    { template: number },
    { template: id },
    { template: creator },
    { template: creation_date },
    { template: sla },
    { template: remaining },
    { template: request_subject },
    { template: related_project },
    { template: current_step },
    { template: assignee },
    { identifier: 'status', template: status },
    { template: action },
  ]">
  <ng-template #number let-row let-i="i">
    {{ ((meta()?.current_page || 1) - 1) * (meta()?.per_page || 25) + (i + 1) }}
  </ng-template>

  <ng-template #id let-row>{{ row.request_id }} </ng-template>

  <ng-template #creator let-row>
    <lib-request-creator [creator]="row.creator" />
  </ng-template>

  <ng-template #creation_date let-row>
    <span dir="ltr">
      {{ row.created_at | date: 'dd-MMM-yyyy hh:mm a' }}
    </span>
  </ng-template>

  <ng-template #sla let-row>
    <div style="width: 83%">
      @if (row.state.value !== parallelStepStatus.INPROGRESS) {
        <div class="flex justify-between gap-sm">
          <span dir="ltr">
            {{ row.finished_at | date: 'dd-MMM-yyyy hh:mm a' }}
          </span>

          @if (row.finished_at > row.due_date) {
            <lib-warning-icon [iconClass]="'size-4 text-destructive-500'" />
          }
        </div>
      }

      @if (row.state.value === parallelStepStatus.INPROGRESS) {
        <div class="flex">
          <span
            libSla
            [clockTemplate]="clockTemplate"
            [sla]="row.due_date"
            dir="ltr">
            ETA: {{ row.due_date | date: 'dd-MMM-yyyy hh:mm a' }}
          </span>
        </div>
      }
    </div>
  </ng-template>

  <ng-template #remaining let-row>
    @if (
      row.state.value !== parallelStepStatus.COMPLETED &&
      row.state.value !== parallelStepStatus.REJECTED
    ) {
      {{ row.remaining_sla }}
    }
  </ng-template>

  <ng-template #request_subject let-row>
    <span
      class="request-subject-width"
      libTrimTooltip
      placement="top"
      [toolTipClass]="'bg-white p-md rounded-lg shadow-lg tooltip-arrow tooltip-arrow-top max-w-[20rem] break-words text-pretty'"
      [trimLength]="22"
      [fullText]="row.request_subject">
    </span>
  </ng-template>

  <ng-template #related_project let-row>
    @if (row?.project) {
      <a
        [routerLink]="['/projects' | tenantPath, row?.project?.id]"
        class="flex items-center gap-md cursor-pointer text-neutral-900 hover:!underline hover:text-primary-500">
        <lib-avatar
          [fullName]="row?.project?.name"
          [img]="row.project?.image?.url"
          borderRadius="rounded-full" />

        <span class="text-xs font-medium">
          {{ row?.project?.name | truncate }}
        </span>
      </a>
    }
  </ng-template>

  <ng-template #current_step let-row>
    {{ row.current_position_name }}
  </ng-template>

  <ng-template #assignee let-row let-i="i">
    @if (row.assignees.length) {
      <lib-user-dropdown-view
        [userCount]="row.assignees.length"
        [userTableList]="row.assignees"
        [userDropdownList]="row.assignees"
        [totalDropdownCount]="row.assignees.length"
        [assigneeType]="row.assigneeType"
        [headerListLabel]="'dropdown_header_list_assignees_label' | transloco"
        [searchLabel]="'dropdown_search_find_assignees_label' | transloco"
        [searchPlaceholder]="'search_by_name_placeholder' | transloco"
        [noSearchResultLabel]="'no_search_result_label' | transloco"
        [enableLocalSearch]="true"
        [imgDimensions]="{ width: 1.5, height: 1.5 }"
        [containerRef]="'history'" />
    }
  </ng-template>

  <ng-template #status let-row>
    <lib-badge
      [label]="row.state.label"
      [badgeClass]="
        'px-sm border-none text-xs font-medium text-white ' +
        (row.state.value | stepStatus)
      "></lib-badge>
  </ng-template>

  <ng-template #action let-row>
    <lib-action-list
      libPermissions
      [featurePermissions]="[appPermissions.workflow.view]"
      [userPermissions]="row.permissions"
      [parentName]="'history'"
      [menuItems]="row.actionList"
      (itemClick)="actionListItemClick($event, row)" />
  </ng-template>
</lib-filtered-table>

<ng-template #archive>
  <lib-archive-confirmation-popup
    [type]="'archive'"
    [isLoading]="isLoading()"
    [titleKey]="'archive_workflow_modal_title'"
    [descriptionKey]="'archive_workflow_modal_description'"
    [highlightedDescriptionKey]="'archive_workflow_modal_highlighted_description'"
    [confirmButtonKey]="'archive_workflow_modal_archive_workflow_button'"
    [cancelButtonKey]="'archive_project_modal_cancel_button'"
    (confirm)="archiveRequest()"
    (closeModal)="closeModal()" />
</ng-template>

<ng-template #restore>
  <lib-archive-confirmation-popup
    [type]="'restore'"
    [isLoading]="isLoading()"
    [titleKey]="'restore_workflow_modal_title'"
    [descriptionKey]="'restore_workflow_modal_description'"
    [highlightedDescriptionKey]="'restore_workflow_modal_highlighted_description'"
    [confirmButtonKey]="'archive_workflow_modal_restore_workflow_button'"
    [cancelButtonKey]="'restore_project_modal_cancel_button'"
    (confirm)="restoreRequest()"
    (closeModal)="closeModal()" />
</ng-template>

<ng-template #clockTemplate let-isOverdue>
  <lib-clock-icon
    [iconClass]="
      'size-4 ' + (isOverdue ? 'text-destructive-500' : 'text-neutral-500')
    " />
</ng-template>
